import React from 'react';
import './style.scss';
import logo from '../../../../assets/images/logo.svg';
import submitIcon from '../../../../assets/images/submittedIcon.svg';
import { withTranslation } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const StepThree = ({t, referenceNumber, emailErrorMessage}) => {
  return (
    <div className="StepThreecontainer">
      {/* header */}
      
      <div className="titleContainer">
        <span className="title">{t('ApplicationSubmitted')}</span>
        <span className="subTitle">
          {t('ApplicationSubmittedSubTitle')}
        </span>
      </div>
      {/* sub Header */}
      <div className="subHeader">
        <div className="firstSpan">
          <span>
            {t('StepThreeSubHeader')}
          </span>
          <span>{t('StepThreeInofDetails')}</span>
        </div>
        <div className="secondSpan">
          <span>{t('FirstPageOfPassportInfo')}</span>

          <span>{t('PassportStampedPage')}</span>
        </div>
      </div>
      {/* card  */}
      <div className="submitCard">
        <img src={submitIcon} alt="submit icon" className="submitIcon" />
        {/* card text */}
        <div className="cardText">
          <div className="cardTitle">
            <span>{t('CardLimitExtended')}</span>
          </div>
          <div className="cardSubTitle">
            <span>
              {t('CreditCardExtensionMessage')}
            </span>
          </div>
          <div className="refNumber">
            <span className='refTitle'>
            {t('ReferenceNumber')}
            </span>
            <span className='refSubTitle'>
            {referenceNumber}
            </span>
            <span className='cardSubTitle'>
            {emailErrorMessage || ''}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(withSitecoreContext()( StepThree));
